import PictureCardPicture from './PictureCardPicture'
export default PictureCardPicture
